import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { CheckCircle2, Circle } from "lucide-react";

export default function ClientHabitsPage() {
    const [habits, setHabits] = useState([]);
    const [home, setHome] = useState(null);

    const load = async () => {
        const [h, d] = await Promise.all([api.get("/habits"), api.get("/me/client-home")]);
        setHabits(h.data);
        setHome(d.data);
    };
    useEffect(() => { load(); }, []);

    const doneMap = {};
    (home?.habits || []).forEach((h) => { doneMap[h.id] = h.done_today; });

    const toggle = async (h) => {
        if (doneMap[h.id]) await api.delete("/habit-logs", { params: { habit_id: h.id } });
        else await api.post("/habit-logs", { habit_id: h.id });
        load();
    };

    return (
        <div className="p-8 space-y-6" data-testid="client-habits-page">
            <div>
                <p className="label-tiny mb-2">/ Every day counts</p>
                <h1 className="font-serif text-6xl">Habits</h1>
            </div>

            {habits.length === 0 ? (
                <div className="border border-dashed border-[var(--border-bright)] p-10 text-center">
                    <p className="font-serif text-2xl mb-2">No habits assigned yet.</p>
                    <p className="text-sm text-[var(--text-muted)]">Your coach will add some. Hydration, sleep, steps — the basics that stack the wins.</p>
                </div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    {habits.map((h) => {
                        const done = doneMap[h.id];
                        return (
                            <button key={h.id} onClick={() => toggle(h)} data-testid={`habit-card-${h.id}`}
                                className={`text-left border p-5 transition-colors ${done ? "border-[var(--gold)] bg-[var(--surface-hover)]" : "border-[var(--border)] bg-[var(--surface)] hover:bg-[var(--surface-hover)]"}`}>
                                <div className="flex items-start justify-between mb-4">
                                    <div>
                                        <p className={`font-serif text-2xl ${done ? "line-through text-[var(--text-muted)]" : ""}`}>{h.name}</p>
                                        {h.target && <p className="text-xs text-[var(--text-muted)] font-mono mt-1">target · {h.target}</p>}
                                    </div>
                                    {done ? <CheckCircle2 size={22} className="text-[var(--gold-bright)]" /> : <Circle size={22} className="text-[var(--text-faint)]" />}
                                </div>
                                <div className="flex items-center justify-between text-xs">
                                    <span className="tag-pill">{h.frequency}</span>
                                    <span className="font-mono text-[var(--text-muted)]">{h.compliance_14d}% · 14d</span>
                                </div>
                            </button>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
